import { trigger, transition, style, animate } from "@angular/animations";

export const disappearFaster = trigger('disappearFaster', [
    transition(':leave', [
        style({ opacity: 1 }),
        animate('400ms', style({ opacity: 0 }))
    ])
  ]);